import styled from 'styled-components'

export const Stepper = styled.ol<{ count: number; current: number }>`
  --stepHeight: 35px;
  --barHeight: 6px;
  --borderWidth: 4px;

  display: flex;
  list-style: none;
  justify-content: space-between;
  padding: 0;
  margin: 8px 10% 7px;
  font-size: 18px;
  font-weight: 400;
  counter-reset: step;
  height: var(--stepHeight);
  position: relative;

  @media (min-width: 768px) {
    --stepHeight: 50px;
    margin: 16px 10% 15px;
  }

  &:before,
  &:after {
    content: '';
    display: block;
    height: 6px;
    background-color: ${({ theme }) => theme.breadcrumb.defaultBarColour};
    position: absolute;
    left: 0;
    right: 0;
    margin-top: 14.5px; // (35  - 6) / 2

    @media (min-width: 768px) {
      margin-top: 22px; // (50  - 6) / 2
    }
  }

  &:after {
    background-color: ${({ theme }) => theme.breadcrumb.completeBarColour};
    right: auto;
    /* 
    transition of bar width doesn't currently work due to breadcrumbs being remounted, but could potentially implement with this:
    transition: width 300ms ease-in-out;
    */
    width: ${({ count, current }) => `${(current * 100) / (count - 1)}%`};
  }
`

export const Step = styled.li`
  display: grid;
  place-items: center;
  gap: var(--barHeight);

  &::before {
    content: counter(step) ' ';
    counter-increment: step;
    display: grid;
    place-content: center;
    height: var(--stepHeight);
    aspect-ratio: 1;
    background: ${({ theme }) => theme.breadcrumb.completeBackgroundColour};
    color: ${({ theme }) => theme.breadcrumb.completeTextColour};
    border: var(--borderWidth) solid
      ${({ theme }) => theme.breadcrumb.completeBorderColour};
    box-sizing: border-box;
    border-radius: 50%;
    z-index: 1;
  }

  &.active::before {
    background: ${({ theme }) => theme.breadcrumb.activeBackgroundColour};
    color: ${({ theme }) => theme.breadcrumb.activeTextColour};
    border: var(--borderWidth) solid
      ${({ theme }) => theme.breadcrumb.activeBorderColour};
  }

  &.active ~ li::before {
    background: ${({ theme }) => theme.breadcrumb.defaultBackgroundColour};
    color: ${({ theme }) => theme.breadcrumb.defaultTextColour};
    border: var(--borderWidth) solid
      ${({ theme }) => theme.breadcrumb.defaultBorderColour};
  }

  &:focus-within::before {
    outline: 2px solid ${({ theme }) => theme.breadcrumb.focusBorderColour};
    outline-offset: 2px;
  }
`

export const StepLink = styled.a`
  height: var(--stepHeight);
  aspect-ratio: 1;
  position: absolute;
  z-index: 10;
  border-radius: 50%;
  :focus {
    outline: none; // focus is handled with focus-within above
  }
`
